import React from "react";
import { withNavBars } from "../../HOCs";
import { Communitybanner } from "./communityBanner";

class CommunitybannerParent extends React.Component {
    render() {
        return <Communitybanner {...this.props}/>;
    }
}
const props = {
    boxShadow: false
}
export default withNavBars(CommunitybannerParent, props);